import { ModuleConfig } from '@/core/module';
import { inAppNotificationRoutes } from './routes';
import { useInAppNotificationStore } from './stores/in-app-notification-store';

export { useInAppNotifications } from './hooks/useInAppNotifications';
export { NotificationBell } from './components/NotificationBell';
export { NotificationList } from './components/NotificationList';
export { NotificationItem } from './components/NotificationItem';
export { NotificationDrawer } from './components/NotificationDrawer';
export { InAppNotificationListView } from './views/InAppNotificationListView';

export const InAppNotificationModule: ModuleConfig = {
    name: 'in-app-notifications',
    routes: inAppNotificationRoutes,
    stores: {
        inAppNotification: useInAppNotificationStore,
    },
    initialize: () => {
        console.log('InAppNotification module initialized');
    },
};
